import { db } from '@/plugins/firebase';

const meeting_collectionName = "meeting";

export async function getMeeting(liveId) {
  const meeting = await db.collection(meeting_collectionName).doc(liveId).get();
  return meeting.data();
}

export async function updateMeetingDoc(liveId, meetingData) {
  let success = true;
  const meetingDocRef = await db.collection(meeting_collectionName).doc(liveId);
  await meetingDocRef
    .set(
      {
        meeting: meetingData
      },
      { merge: true }
    )
    .catch(err => {
      console.error(err);
      success = false;
    });

  if (!success) return;

  const meeting = await meetingDocRef.get();
  return meeting.data();
}

export async function deleteMeeting(liveId) {
  let success = true;

  await db.collection(meeting_collectionName).doc(liveId).delete().catch(err => {
      console.error(err);
      success = false;
    });

  return success;
}